import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_ORIGIN = "https://palletrackingusa.com";

/**
 * Sets a self-referencing <link rel="canonical"> for the current route.
 * Strips trailing slashes (except root "/") and query params so the
 * canonical always points to the clean preferred URL.
 */
export function useCanonical() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Normalize: remove trailing slash (keep "/" for root)
    const clean = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    const canonical = `${SITE_ORIGIN}${clean}`;

    let link = document.querySelector<HTMLLinkElement>("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [pathname]);
}
